module.exports = __webpack_public_path__ + "static/media/mccumber.f8b79ccc.webp";